module.exports = __webpack_public_path__ + "img/banner4.db7cf2a6.png";